import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const overlayVariantClasses = {
    // Dialog + AlertDialog: dimmer scrim, blurred backdrop, no open/close transition.
    modal: 'fixed inset-0 z-50 bg-black/40 backdrop-blur-sm',
    // Sheet: darker scrim, no blur, fades in/out with the drawer's own animation.
    sheet: 'fixed inset-0 z-40 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
};
/** The class string for one overlay variant, with an optional caller override merged on top. */
export function overlayClassName(variant, className) {
    return cn(overlayVariantClasses[variant], className);
}
/**
 * Wraps a Radix `Overlay` primitive with the shared forwardRef +
 * className-merge shape, defaulting to one `OverlayVariant`'s classes.
 *
 * Generic over the underlying Radix component so both
 * `DialogPrimitive.Overlay` (Dialog, Sheet) and
 * `AlertDialogPrimitive.Overlay` (AlertDialog) — distinct packages, identical
 * `{ ref, className, ...props }` shape — can share this one factory.
 */
export function createOverlayPrimitive(// eslint-disable-line @typescript-eslint/no-explicit-any
OverlayPrimitiveComponent, variant, displayName) {
    // The generic `T` defeats JSX's normal ref-type checking for a component
    // reference passed in as a value (TS can't prove an arbitrary `T` accepts a
    // `ref`), so the element itself is built through an `any`-typed view of the
    // same component — the outer forwardRef signature above is what callers
    // (and TS) actually see and get checked against.
    const AnyOverlayPrimitiveComponent = OverlayPrimitiveComponent; // eslint-disable-line @typescript-eslint/no-explicit-any
    const Overlay = React.forwardRef(({ className, ...props }, ref) => (_jsx(AnyOverlayPrimitiveComponent, { ref: ref, className: overlayClassName(variant, className), ...props })));
    Overlay.displayName = displayName;
    return Overlay;
}
//# sourceMappingURL=overlay.js.map